<script>
    // https://codepen.io/kani339/pen/abBQZopc
    export let show = false;
</script>

<div class="ocrloader {show ? '': 'd-none'}">
    <p>Reviewing</p>
    <em></em>
    <span></span>
</div>

<style>
    .ocrloader {
        width: 92.2%;
        height: 730px;
        margin: 20px;
        outline-offset: 10px;
        /* position: relative; */
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
    }

    .ocrloader span::before {
        content: "";
        position: absolute;
        top: 5%;
        bottom: 0;
        left: 4%;
        width: 10px;
        height: 90%;
        background: #7f5700;
        box-shadow: 0 0 50px 10px #7f5700;
        clip-path: inset(0);
        animation:
            x 1s ease-in-out infinite alternate,
            y 1s ease-in-out infinite;
    }

    .ocrloader p::before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #7f5700;
        position: relative;
        right: 4px;
    }

    .ocrloader p {
        color: #7f5700;
        position: absolute;
        bottom: -30px;
        left: 38%;
        font-size: 16px;
        font-weight: 600;
        animation: blinker 1s linear infinite;
        font-family: sans-serif;
        text-transform: uppercase;
    }

    .ocrloader:before,
    .ocrloader:after,
    .ocrloader em:after,
    .ocrloader em:before {
        border-color: #7f5700;
        content: "";
        position: absolute;
        width: 45px;
        height: 46px;
        border-style: solid;
        border-width: 0px;
    }

    .ocrloader:before {
        left: 0;
        top: 0;
        border-left-width: 5px;
        border-top-width: 5px;
        border-radius: 23px 0 0 0;
    }

    .ocrloader:after {
        right: 0;
        top: 0;
        border-right-width: 5px;
        border-top-width: 5px;
        border-radius: 0 23px 0 0;
    }
    .ocrloader em:before {
        left: 0;
        bottom: 0;
        border-left-width: 5px;
        border-bottom-width: 5px;
        border-radius: 0 0 0 23px;
    }
    .ocrloader em:after {
        right: 0;
        bottom: 0;
        border-right-width: 5px;
        border-bottom-width: 5px;
        border-radius: 0 0 23px 0;
    }

    @keyframes move {
        0%,
        100% {
            transform: translateY(190px);
        }
        50% {
            transform: translateY(0%);
        }
        75% {
            transform: translateY(160px);
        }
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }

    @keyframes x {
        to {
            transform: translateX(-100%);
            left: 100%;
        }
    }

    @keyframes y {
        33% {
            clip-path: inset(0 0 0 -100px);
        }
        50% {
            clip-path: inset(0 0 0 0);
        }
        83% {
            clip-path: inset(0 -100px 0 0);
        }
    }
</style>
